<section>
  <div class="mb-2">
    <form novalidate [formGroup]="formFormatDetail">
      <div class="row p-1">
        <div class="col field-name">
          <app-custom-input-text formControlName="name" [labelText]="'Nombre'" [required]="true" [recovery]="true"
            (onChangeText)="changeFormatDetailForm()"></app-custom-input-text>
        </div>
        <div class="col field-description">
          <app-custom-input-text formControlName="description" [labelText]="'Descripción'"></app-custom-input-text>
        </div>
        <div class="col field-band">
          <app-custom-select formControlName="band" [labelText]="'Banda'" [list]="listBand"
            [required]="true"></app-custom-select>
        </div>
        <div class="col field-type">
          <app-custom-select formControlName="type" [labelText]="'Tipo'" [list]="listType" [required]="true"
            (onChangeSelect)="changeType()"></app-custom-select>
        </div>
        <div class="col field-visible d-flex align-items-end mb-1">
          <app-custom-checkbox formControlName="visible" [labelText]="'Visible'"></app-custom-checkbox>
        </div>
        <div class="col field-x">
          <app-custom-input-decimal formControlName="left" [labelText]="'Eje X'" [required]="true"
            [maxFractionDigits]="4"></app-custom-input-decimal>
        </div>
        <div class="col field-y">
          <app-custom-input-decimal formControlName="top" [labelText]="'Eje Y'" [required]="true"
            [maxFractionDigits]="4"></app-custom-input-decimal>
        </div>
        <div class="col field-width">
          <app-custom-input-decimal formControlName="width" [labelText]="'Width'" [required]="true"
            [maxFractionDigits]="4"></app-custom-input-decimal>
        </div>
        <div class="col field-height">
          <app-custom-input-decimal formControlName="height" [labelText]="'Height'" [required]="true"
            [maxFractionDigits]="4"></app-custom-input-decimal>
        </div>
        <div class="col field-font-size">
          <app-custom-input-number formControlName="fontSize" [labelText]="'FontSize'"
            [required]="true"></app-custom-input-number>
        </div>
        <div class="col field-bold">
          <app-custom-select formControlName="bold" [labelText]="'Bold'" [list]="listBold"
            [required]="true"></app-custom-select>
        </div>
        <div class="col field-alignment">
          <app-custom-select formControlName="alignment" [labelText]="'Alignment'" [list]="listAlignment"
            [required]="true"></app-custom-select>
        </div>
        <div class="col field-border">
          <app-custom-select formControlName="border" [labelText]="'Border'" [list]="listBorder"
            [required]="true"></app-custom-select>
        </div>
        <div class="col field-text">
          <app-custom-input-text formControlName="text" [labelText]="'Texto'"></app-custom-input-text>
        </div>
        <div class="col field-font-size">
          <app-custom-input-number formControlName="orderTable" [labelText]="'Orden'"
            [required]="true"></app-custom-input-number>
        </div>
        <div class="col field-print-format">
          <app-custom-input-text formControlName="printFormat" [labelText]="'Formato'"></app-custom-input-text>
        </div>
        <div class="field-buttons d-flex align-items-end justify-content-end mt-2 gap-2">
          <app-custom-button [title]="'Guardar'" [label]="'Guardar'" (onClick)="send()"></app-custom-button>
          <app-custom-button [title]="'Cancelar'" [label]="'Cancelar'" [severity]="'danger'"
            (onClick)="clearForm()"></app-custom-button>
        </div>
      </div>
    </form>
  </div>
</section>